<template>
  <div class="">
    <div class="flex justify-between mb-2 mx-6">
      <h1 class="pt-1">Tips</h1>
    </div>

    <div class="horizontal-scroll py-2 pl-6">
      <div class="card shadow-none bg-teal-500 mr-5 tips-item">
        <h2 class="">Cara Transaksi Laundry</h2>
        <img
          src="../../assets/icon/transaksi.png"
          class="h-20 mx-auto mt-3"
          alt=""
        />
      </div>
      <div class="card shadow-none bg-yellow-400 tips-item">
        <h2 class="">Cara Pembayaran Laundry</h2>
        <img
          src="../../assets/icon/pembayaran.png"
          class="h-20 mx-auto mt-3"
          alt=""
        />
      </div>
      <div class="w-12 p-3"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
